import { Message, Messages } from '$store/models';

export const filterContentKeys = (keysToFilter: string[], content: Messages) => {
  const filteredContent: Message[] = [];

  for (const key of keysToFilter) {
    if (content.hasOwnProperty(key)) {
      filteredContent.push(content[key]);
    }
  }

  return filteredContent;
};
